<template>

  <b-row align-v="end" align-h="start">
    <b-col cols="2">
      <md-field md-clearable>
        <label>{{$t('Type to Search')}}</label>
        <md-input v-model="filter" @update="filterChanged"></md-input>
      </md-field>
    </b-col>

    <b-col cols="2">
      <md-field>
        <label for="perPage">{{$t('Per page')}}</label>
        <md-select v-model="perPage" @md-selected="paginationChanged">
          <md-option v-for="item in pageOptions" :key="item" :value="item"> {{ item }} </md-option>
        </md-select>
      </md-field>
    </b-col>

    <b-col cols="3">
      <b-row>
        <b-col>
          <md-field>
              <data-picker style="font-size:16px" class="md-input" ref="DPstart" @update-date="onChangedDateStart" date-format="dd-mm-yy" ></data-picker>
          </md-field>
        </b-col>
        <b-col>
          <md-field>
              <data-picker style="font-size:16px" class="md-input" ref="DPend" @update-date="onChangedDateEnd" date-format="dd-mm-yy" ></data-picker>
          </md-field>
        </b-col>
      </b-row>
    </b-col>

    <b-col cols="3">
      <md-field>
        <label for="selected">{{$t('Time Span')}}</label>
        <md-select v-model="selected">
          <md-option v-for="item in optionsTime" :key="item.value" :value="item.value"> {{ item.text }} </md-option>
        </md-select>
      </md-field>
    </b-col>

    <b-col cols="1">
        <md-button block @click.stop="generate" class="md-raised" size="sm" :disabled="isGenerateDisabled">{{ $t('Generate') }}</md-button>
    </b-col>
  </b-row>
</template>

<style>
.md-field {
  margin: 6px 8px;
}
</style>

<script>
import moment from 'moment'

export default {
  props: {
    filterOptions: {
      isFilterGroup: false,
      isFilterTypeTraffic: false,
      isFilterTypeDocuments: false,
      isFilterTypeUsers: false,
      isFilterCollector: false,
      isDownloadable: false,
      hasLimitRows: true
    },
    isGenerateDisabled: false,
    isDownloadDisabled: false
  },
  data () {
    return {
      from: 0,
      to: 0,
      selectCollector: 0,
      selectTypeTraffic: 0,
      selectTypeUsers: 0,
      selectTypeDocuments: 1,
      selectGroup: 0,
      optionsCollector: [],
      filter: '',
      pageOptions: [20, 40, 60, 80, 100],
      limitOptions: [500, 1000, 5000, 0],
      perPage: 20,
      limitRows: 0,
      dateStart: Date('1969-01-01'),
      dateEnd: Date('2050-10-10'),
      selected: 3,
      optionsTraffic: [
        { text: '---', value: 0 },
        { text: this.$i18n.t('Gruopped by hour'), value: 1 },
        { text: this.$i18n.t('Gruopped by day'), value: 2 },
        { text: this.$i18n.t('Gruopped by month'), value: 3 },
        { text: this.$i18n.t('Gruopped by IPv4'), value: 4 },
        { text: this.$i18n.t('Gruopped by group'), value: 5 },
        { text: this.$i18n.t('Gruopped by IPv6'), value: 6 }
      ],
      optionsDocuments: [
        { text: this.$i18n.t('Invoice'), value: 1 },
        { text: this.$i18n.t('VAT invoice'), value: 2 },
        { text: this.$i18n.t('Acceptance report'), value: 4 },
        { text: this.$i18n.t('Detail invoice'), value: 7 } ],
      optionsTime: [
        { text: this.$i18n.t('Current Day'), value: 0 },
        { text: this.$i18n.t('Current Week'), value: 1 },
        { text: this.$i18n.t('Current Month'), value: 2 },
        { text: this.$i18n.t('Current Year'), value: 3 },
        { text: this.$i18n.t('Manually'), value: 4 }
      ],
      optionsTypeUseres: [
        { text: this.$i18n.t('All'), value: 0 },
        { text: this.$i18n.t('Correction of invoice positions'), value: 1 },
        { text: this.$i18n.t('Balance correction'), value: 2 },
        { text: this.$i18n.t('Adding user'), value: 3 },
        { text: this.$i18n.t('Editing user'), value: 4 },
        { text: this.$i18n.t('Deleting user'), value: 5 },
        { text: this.$i18n.t('Adding IP Group'), value: 6 },
        { text: this.$i18n.t('Editing IP group'), value: 7 },
        { text: this.$i18n.t('Adding user group'), value: 8 },
        { text: this.$i18n.t('Deleting user group'), value: 9 },
        { text: this.$i18n.t('Editing user group'), value: 10 },
        { text: this.$i18n.t('Adding user to group'), value: 11 },
        { text: this.$i18n.t('Removing user from group'), value: 12 },
        { text: this.$i18n.t('Adding account'), value: 13 },
        { text: this.$i18n.t('Editing account'), value: 14 },
        { text: this.$i18n.t('Adding service'), value: 15 },
        { text: this.$i18n.t('Editing service'), value: 16 },
        { text: this.$i18n.t('Users group operations'), value: 17 },
        { text: this.$i18n.t('Adding tariff'), value: 18 },
        { text: this.$i18n.t('Editing tariff'), value: 19 },
        { text: this.$i18n.t('Deleting tariff'), value: 20 },
        { text: this.$i18n.t('Adding service to tariff'), value: 21 },
        { text: this.$i18n.t('Deleting service from tariff'), value: 22 },
        { text: this.$i18n.t('Unlinking tariff from account'), value: 23 },
        { text: this.$i18n.t('Linking tariff to account'), value: 24 },
        { text: this.$i18n.t('Adding additional settings parameter'), value: 25 },
        { text: this.$i18n.t('Editing additional settings parameter'), value: 26 },
        { text: this.$i18n.t('Deleting additional settings parameter'), value: 27 },
        { text: this.$i18n.t('Instant tariff change'), value: 28 },
        { text: this.$i18n.t('Policy change'), value: 29 },
        { text: this.$i18n.t('Additing technical parameter'), value: 30 },
        { text: this.$i18n.t('Editing technical parameter'), value: 31 },
        { text: this.$i18n.t('Deleting technical parameter'), value: 32 },
        { text: this.$i18n.t('Cost coefficient change'), value: 37 }
      ]
    }
  },
  watch: {
    filter: function (val) {
      this.$emit('filterChanged', val)
    },
    selectGroup: function (val) {
      this.$emit('onChangedGroup', val)
    },
    selectTypeDocuments: function (val) {
      this.$emit('onChangedTypeDocuments', val)
    },
    selectTypeUsers: function (val) {
      this.$emit('onChangedTypeUsers', val)
    },
    selectTypeTraffic: function (val) {
      this.$emit('onChangedTypeTraffic', val)
    },
    selectCollector: function (val) {
      this.$emit('onChangedCollector', val)
    },
    selected: function (val) {
      var currentDate = moment()
      switch (val) {
        case 0 :
          this.dateStart = currentDate.format('YYYY-MM-DD')
          this.dateEnd = currentDate.subtract(-1, 'days').format('YYYY-MM-DD')
          break
        case 1 :
          this.dateStart = moment().startOf('isoweek').format('YYYY-MM-DD')
          this.dateEnd = moment().endOf('isoweek').subtract(-1, 'days').format('YYYY-MM-DD')
          break
        case 2 :
          this.dateStart = moment().startOf('month').format('YYYY-MM-DD')
          this.dateEnd = moment().endOf('month').subtract(-1, 'days').format('YYYY-MM-DD')
          break
        case 3 :
          this.dateStart = moment().startOf('year').format('YYYY-MM-DD')
          this.dateEnd = moment().endOf('year').subtract(-1, 'days').format('YYYY-MM-DD')
          break
        case 4 :
          this.dateStart = moment().calendar()
          this.dateEnd = moment().calendar()
      }
      let dateStartFormatted = this.dateFormatingYYYYMMDD(this.dateStart)
      let dateEndFormatted = this.dateFormatingYYYYMMDD(this.dateEnd)
      if (dateStartFormatted) this.$emit('onChangedDateStart', new Date(dateStartFormatted.year, dateStartFormatted.month, dateStartFormatted.day))
      if (dateEndFormatted) this.$emit('onChangedDateEnd', new Date(dateEndFormatted.year, dateEndFormatted.month, dateEndFormatted.day))
      this.$refs.DPstart.setDate(new Date(this.dateStart))
      this.$refs.DPend.setDate(new Date(this.dateEnd))
    }
  },
  methods: {
    async loadCollector () {
      await this.$store.dispatch('Settings/GET_COLLECTORS', this.getStore).then(response => {
        let optionsCollector = this.$store.getters['Settings/COLLECTORS']
        for (let el of optionsCollector) {
          let newEl = {
            value: 0,
            text: ''
          }
          newEl.value = el.id
          newEl.text = el.name + ' (' + el.comments + ')'
          this.optionsCollector.push(newEl)
        }
        let newEl = {
          value: 0,
          text: '---'
        }
        this.optionsCollector.push(newEl)
      })
    },
    filterChanged () {
      this.$emit('filterChanged', this.filter)
    },
    paginationChanged () {
      this.$emit('paginationChanged', this.perPage)
    },
    limitRowsChanged () {
      this.$emit('limitChanged', this.limitRows)
    },
    dateFormatingDDMMYYYY (date) {
      let pattern = '(\\d\\d)-(\\d\\d)-(\\d\\d\\d\\d)'
      let groups = date.match(pattern)
      return {year: parseInt(groups[3]), month: parseInt(groups[2] - 1), day: parseInt(groups[1])}
    },
    dateFormatingYYYYMMDD (date) {
      let pattern = '(\\d\\d\\d\\d)-(\\d\\d)-(\\d\\d)'
      let groups = date.match(pattern)
      if (groups) {
        return {year: parseInt(groups[1]), month: parseInt(groups[2] - 1), day: parseInt(groups[3])}
      }
    },
    onChangedDateStart (date) {
      let dateFormatted = this.dateFormatingDDMMYYYY(date)
      this.$emit('onChangedDateStart', new Date(dateFormatted.year, dateFormatted.month, dateFormatted.day))
    },
    onChangedDateEnd (date) {
      let dateFormatted = this.dateFormatingDDMMYYYY(date)
      this.$emit('onChangedDateEnd', new Date(dateFormatted.year, dateFormatted.month, dateFormatted.day))
    },
    generate () {
      this.$emit('generate')
    },
    download () {
      this.$emit('download')
    }

  },
  computed: {
    optionsGroup () {
      let tmp = []
      let newEl = {
        value: 0,
        text: '---'
      }
      tmp.push(newEl)
      for (let el of this.$store.getters['Users/GROUPS']) {
        let newEl = {
          value: 0,
          text: ''
        }
        newEl.value = el.group_id
        newEl.text = el.group_name
        tmp.push(newEl)
      }
      return tmp
    }
  },
  mounted () {
    this.$emit('onChangedDateStart', new Date('1970-01-01'))
    this.$emit('onChangedDateEnd', new Date('2050-10-10'))
    if (this.filterOptions.isFilterGroup && this.$store.getters['Users/GROUPS'].length === 0) {
      this.$store.dispatch('Users/GET_GROUPS')
    }
    if (this.filterOptions.isFilterCollector) {
      this.loadCollector()
    }
    this.dateStart = moment().startOf('year').format('YYYY-MM-DD')
    this.dateEnd = moment().endOf('year').subtract(-1, 'days').format('YYYY-MM-DD')
    let dateStartFormatted = this.dateFormatingYYYYMMDD(this.dateStart)
    let dateEndFormatted = this.dateFormatingYYYYMMDD(this.dateEnd)
    if (dateStartFormatted) this.$emit('onChangedDateStart', new Date(dateStartFormatted.year, dateStartFormatted.month, dateStartFormatted.day))
    if (dateEndFormatted) this.$emit('onChangedDateEnd', new Date(dateEndFormatted.year, dateEndFormatted.month, dateEndFormatted.day))
    this.$refs.DPstart.setDate(new Date(this.dateStart))
    this.$refs.DPend.setDate(new Date(this.dateEnd))
  }
}

</script>



// WEBPACK FOOTER //
// src/components/tables/TelephonyOperatorsReportHeader.vue